import { SportingSecureParams } from '../../types';
import { getSportingServiceURL } from '../../utils/getSportingURL';
import { createSportingHeaders } from '../../utils/createSportingHeaders';
import { appendFormDataWithObjectValues } from 'utils/appendFormDataWithObjectValues';
import { customFetch } from 'utils/customFetch';
import { UnexpectedError } from 'utils/errors';

type Pyload = {
  idUser: number;
  phoneNumber: string;
};

export const setEmployeeMobilePhone = async (
  params: SportingSecureParams<Pyload>
): Promise<void> => {
  const { payload } = params;

  const endpointURL = getSportingServiceURL('setEmployeeMobilePhone');

  const headers = createSportingHeaders();

  const body = new FormData();
  appendFormDataWithObjectValues(body, payload);

  const response = await customFetch(endpointURL, {
    method: 'POST',
    headers,
    body
  });

  if (!response.ok) {
    throw new UnexpectedError();
  }
};
